/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ seats: NonNullable<unknown>, perUser: NonNullable<unknown> }} Usage_Tab_Pool_Size_SubInputs */



/**
* | output |
* | --- |
* | "{seats} × €{perUser}" |
*
* @param {Usage_Tab_Pool_Size_SubInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const usage_tab_pool_size_sub = /** @type {((inputs: Usage_Tab_Pool_Size_SubInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Usage_Tab_Pool_Size_SubInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.seats} × €${i?.perUser}`)
	return /** @type {LocalizedString} */ (`${i?.seats} × €${i?.perUser}`)
});